import { ListingsEntity } from './models/listings-entity';

export const LISTINGS: ListingsEntity[] = [
  {
    id: 'Mock-1',
    jobTitle: 'Zoo Keeper',
    date: '03/15/21',
    tags: '#Angular #JavaScript #Developer #Programmer #Coder',
    company: 'Mos Eisley Zootopia',
    description: '"Lorem ipsum dolor sit amet, consectetur adipiscing elit."',
  },
  {
    id: 'Mock-2',
    jobTitle: 'Zoo Keeper',
    date: '03/17/21',
    tags: '#Angular #JavaScript #Developer #Programmer #Coder',
    company: 'Mos Eisley Zootopia',
    description:
      '"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."',
  },
  {
    id: 'Mock-3',
    jobTitle: 'Zoo Keeper',
    date: '02/21/21',
    tags: '#Angular #JavaScript #Developer #Programmer #Coder',
    company: 'Mos Eisley Zootopia',
    description:
      '"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."',
  },
  {
    id: 'Mock-4',
    jobTitle: 'Zoo Keeper',
    date: '03/18/21',
    tags: '#Angular #JavaScript #Developer #Programmer #Coder',
    company: 'Mos Eisley Zootopia',
    description:
      '"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."',
  },
  {
    id: 'Mock-5',
    jobTitle: 'Zoo Keeper',
    date: '03/15/21',
    tags: '#Angular #JavaScript #Developer #Programmer #Coder',
    company: 'Mos Eisley Zootopia',
    description:
      '"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."',
  },
];
